import request from '@/utils/request'

export function verify(name, ssn1, ssn2, info) {
    let params = {
        accessType: info.accessType,
        requireType: 'R'
    }

    if(info.accessType === 'O' || info.accessType === 'PO' || info.accessType === 'E') {
        params.custType = info.custType
        params.dealCd = info.dealCd
        params.entrRqstFomNo = info.entrRqstFomNo
        params.opmkNo = info.opmkNo
        params.applType = info.applType
        if(info.appfNo) {
          params.appfNo = info.appfNo
        }
      }

      return request({
        url: '/ococ/datacapture/auth/custCertiMgmt',
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'custNm': window.btoa(encodeURIComponent(name)), //success sample '7Iah7JiB7J20'
          'custPersId': window.btoa(ssn1 + ssn2) //success sample 'NTkwODI1MTQ4OTYyOA=='
        },
        params
      })
}

export function getColorList(devcMdlCd) {
    let params = {
        nextOperatorId: '1100000266',
        devcMdlCd: devcMdlCd
    }
    return request({
        url: '/uplus/intuser/rc/el/lc/baseInfo/v1/devcMdlClr',
        method: 'get',
        params
    })
}

